import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'fun-register-company-partners',
  templateUrl: './register-company-partners.component.html',
  styleUrls: ['./register-company-partners.component.scss'],
})
export class RegisterCompanyPartnersComponent implements OnInit {

  @Output() public sendDataEvent = new EventEmitter<any>();

  public partnerForm: UntypedFormGroup;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorAmount = false;
  public errorConcept = false;

  constructor(
    public chdRef: ChangeDetectorRef,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    this.partnerForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      surname: new UntypedFormControl('', [Validators.required]),
      //ownershipPercentaje: new FormControl('', [Validators.required, Validators.min(25), Validators.max(100)]),
      birthDate: new UntypedFormControl('', [Validators.required]),
    });
    this.chdRef.detectChanges();
  }

  getInfo() {
    const model = {
      valid: this.partnerForm.valid,
      data: this.partnerForm.value
    }
    this.sendDataEvent.emit(model);
    this.chdRef.detectChanges();
  }

  resetForm() {
    this.partnerForm.reset();
    this.chdRef.detectChanges();
  }

}
